import { useTranslation } from "react-i18next"

import { WithChildren } from "@/utils/utilityTypes"

export const StatusBar = ({ children }: WithChildren) => {
  const { t } = useTranslation()
  return (
    <div
      role="contentinfo"
      aria-label={t("reactiveTrader.meta")}
      className="z-20 flex h-8 max-h-8 min-h-8 w-full items-center justify-end gap-sm px-4"
    >
      {children}
    </div>
  )
}
